/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown>, action: NonNullable<unknown> }} Endpoint_Faq_HeadingInputs */

const en_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About the ${i?.platform} ${i?.action} API`)
};

const zh_hans1_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`关于 ${i?.platform} ${i?.action} API`)
};

const pt_br2_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre o endpoint ${i?.action} da API para ${i?.platform}`)
};

const es_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acerca del endpoint ${i?.action} de la API de ${i?.platform}`)
};

const fr_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À propos de l’API ${i?.platform} ${i?.action}`)
};

const de_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Über die ${i?.platform}-${i?.action}-API`)
};

const ru_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Об API ${i?.platform} ${i?.action}`)
};

const it_endpoint_faq_heading = /** @type {(inputs: Endpoint_Faq_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sull'API ${i?.platform} ${i?.action}`)
};

/**
* | output |
* | --- |
* | "About the {platform} {action} API" |
*
* @param {Endpoint_Faq_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_faq_heading = /** @type {((inputs: Endpoint_Faq_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Faq_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_faq_heading(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_faq_heading(inputs)
	if (locale === "es") return es_endpoint_faq_heading(inputs)
	if (locale === "fr") return fr_endpoint_faq_heading(inputs)
	if (locale === "de") return de_endpoint_faq_heading(inputs)
	if (locale === "ru") return ru_endpoint_faq_heading(inputs)
	if (locale === "it") return it_endpoint_faq_heading(inputs)
	return en_endpoint_faq_heading(inputs)
});